import Model, { obj_with_default } from '/lib/model'
import humanize from 'underscore.string/humanize'

export default \
class BulkCustomization extends Model
  @className: 'BulkCustomization'

  @belongsTo 'listing', model: 'Listing'
  @belongsTo 'user',    model: 'User'

  @computed 'transitions', ->
    ret = {}
    for tr in state_actions[@state] or []
      ret[tr] = transition_name_overrides?[tr] or humanize tr
    ret

export states = $w 'initial validating in_progress rollback success failed cancelled publishing'

export state_options = value: state, label: humanize state for state in states

export state_actions = obj_with_default [],
  initial:          $w 'validate_customizations process_customizations mark_failed'
  validating:       $w 'validate_customizations limit_exceeded process_customizations mark_failed'
  in_progress:      $w 'process_customizations do_rollback push_to_kafka'
  rollback:         $w 'do_rollback mark_failed cancel'
  publishing:       $w 'mark_success'
